import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { ProductData, ProductReference } from "@/features/sub-families/types";
import type { Nullable } from "@/types";

type State = {
    currentProductReference: Nullable<ProductReference>;
    items: ProductData;
    isInitialCheck: boolean;
};

const initialState: State = {
    currentProductReference: null,
    items: {},
    isInitialCheck: true,
};

const slice = createSlice({
    name: "products",
    initialState,
    reducers: {
        productsSetCurrentProductReferenceAction: (state: State, action: PayloadAction<Nullable<ProductReference>>) => {
            state.currentProductReference = action.payload;
            state.isInitialCheck = false;
        },
        productsSetAction: (state: State, action: PayloadAction<ProductData>) => {
            state.items = action.payload;
        },
    },
});

export const { productsSetCurrentProductReferenceAction, productsSetAction } = slice.actions;

export default slice.reducer;
